import { ApiUrl, crosstableWithoutApi } from 'src/constants';
import { httpService } from 'src/services';
import type { HydraResponse, Response } from 'src/api/hydraResponse';
import type { IComplex } from 'src/typings/complexes';
import type { ComplexInitialData } from 'src/components/profileComponents/Complexes/types';

export function getComplexData(token: string, id: string) {
  return httpService.get(`${ApiUrl.getApiUrl().getComplexes}/${id}`, {}, {
    Authorization: `Bearer ${token}`,
  });
}

export function getComplexDataByGetParams(token: string, getParams?: string): Promise<HydraResponse<IComplex[]>> {
  return httpService.get(`${ApiUrl.getApiUrl().getComplexes}?${getParams}`, {}, {
    Authorization: `Bearer ${token}`,
  });
}

export function getComplexWithoutDev(token: string = '') {
  return httpService.get(`${ApiUrl.getApiUrl().getComplexes}?exists[developers]=false&pagination=false&showInCrosstable=true`, {}, {
    Authorization: `Bearer ${token}`,
  });
}

export function getComplexByAmoPipeline(token: string = '', id: string) {
  return httpService.get(`${ApiUrl.getApiUrl().getComplexes}?amo_pipeline.amo_id=${id}&pagination=false`, {}, {
    Authorization: `Bearer ${token}`,
  });
}

export function postComplexData(token: string = '', data: any) {
  return httpService.post(`${ApiUrl.getApiUrl().getComplexes}`, data, {
    Authorization: `Bearer ${token}`,
  });
}

export function patchComplexData(token: string = '', id: string|number, data: any) {
  return httpService.patch(`${ApiUrl.getApiUrl().getComplexes}/${id}`, data, {
    Authorization: `Bearer ${token}`,
  });
}

export function putComplexData(token: string = '', id: string|number, data: any) {
  return httpService.put(`${ApiUrl.getApiUrl().getComplexes}/${id}`, data, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/ld+json',
  });
}

export function putAssignAllUsersToComplex(token: string = '', id: string|number) {
  return httpService.put(`${ApiUrl.getApiUrl().assignAllUsersToComplex}/${id}`, {}, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/ld+json',
  });
}

export function getComplexCreateInitial(token: string = ''): Promise<Response<ComplexInitialData>> {
  return httpService.get(`${ApiUrl.getApiUrl().getComplexCreateInitial}`, {}, {
    Authorization: `Bearer ${token}`,
  });
}

export function putComplexLocationData(link: string, token: string = '', data: any) {
  return httpService.put(`${crosstableWithoutApi}${link}`, data, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/ld+json',
  });
}
